import { useNavigate } from 'react-router-dom'
import { useHoverMenuContext } from './HoverMenuContext'
import { MenuSubItem } from '../menuTypes'

export function NavItem({
  row,
  rowIndex,
  setIsModalOpen,
}: {
  row: MenuSubItem
  rowIndex: number
  setIsModalOpen: (status: boolean) => void
}) {
  const navigate = useNavigate()
  const {
    subOpen,
    handleSubEnter,
    handleSubLeave,
    cancelClose,
    isTouchDevice,
  } = useHoverMenuContext()

  const hasSubmenu = row.subs && row.subs.some((col) => col.length > 0)

  const handleClick = (e: React.MouseEvent | React.TouchEvent) => {
    if (row.modal) {
      setIsModalOpen(true)
      return
    }

    if (/(http(s?)):\/\//i.test(row.url)) {
      window.open(row.url, '_blank')
      return
    }

    if (isTouchDevice && hasSubmenu) {
      if (subOpen?.name !== row.name) {
        e.preventDefault?.()
        e.stopPropagation?.()
        cancelClose()
        handleSubEnter({
          name: row.name,
          rowIndex,
          hasSubmenu,
          subs: row.subs,
          trigger: e.currentTarget as HTMLElement,
        })
        return
      }
    }

    navigate(row.url)
  }

  const shouldHide =
    subOpen && subOpen.name !== row.name && rowIndex > subOpen.rowIndex

  return (
    <div className={`relative py-3 ${shouldHide ? 'hidden' : ''}`}>
      <button
        onClick={handleClick}
        onMouseEnter={
          !isTouchDevice
            ? (e) =>
                handleSubEnter({
                  name: row.name,
                  rowIndex,
                  hasSubmenu,
                  subs: row.subs,
                  trigger: e.currentTarget as HTMLElement,
                })
            : undefined
        }
        onMouseLeave={!isTouchDevice ? handleSubLeave : undefined}
        className='text-base sm:text-sm lg:text-base xl:text-lg  font-medium xl:font-bold leading-normal tracking-wide text-[#001A3D] hover:text-[#6596D7] cursor-pointer'
      >
        {row.name}
      </button>
    </div>
  )
}
